import { userAPI } from '@/services-ts/axios'
import { Alert, Confirm, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

import type {
  ICheckMFA,
  IGetIsSecurlyPassword,
  IGetUserList,
  IGetUserListByFilter,
  IPaging,
  IRenewPassword,
  IResetPassword,
  ISendActivationMessage,
} from '@/types/Request'

export const useUserStore = defineStore('user', {
  actions: {
    async GetUserList(payload: IGetUserList) {
      const response = await userAPI.UserServices.GetUserList(payload)
      return response.status ? response : { data: [], total: 0 }
    },

    async GetUserListByFilter(payload: IGetUserListByFilter) {
      const response = await userAPI.UserServices.GetUserListByFilter(payload)
      return response.status ? response : { data: [], total: 0 }
    },

    async GetIsSecurlyPassword(payload: IGetIsSecurlyPassword) {
      const { data } = await userAPI.UserServices.GetIsSecurlyPassword(payload)
      return data
    },

    async ResetPassword(payload: IResetPassword) {
      const { status } = await userAPI.UserServices.ResetPassword(payload)
      if (status) {
        await Confirm({
          title: Format('admin_global_success'),
          message: Format('admin_pages_user_forgotpassword_successmessage'),
          timer: 5000,
          confirmText: Format('admin_global_ok'),
        })
      }
    },

    async RenewPassword(payload: IRenewPassword) {
      const { status } = await userAPI.UserServices.RenewPassword(payload)
      if (status) {
        void Alert({
          title: Format('admin_global_success'),
          message: Format('admin_pages_user_resetpassword_youcanlogin'),
          timer: 5000,
        })
      }
    },

    async GetPasswordResetLink(targetUserId: string) {
      const { status, data, message } =
        await userAPI.UserServices.GetResetPasswordLink(targetUserId)
      if (status) {
        Alert({
          type: 'success',
          message: Format('admin_copied'),
        })

        return data
      } else {
        Alert({
          type: 'danger',
          message: message || '',
        })
      }
    },

    async SendActivationMessage(payload: ISendActivationMessage) {
      const { status } = await userAPI.UserServices.SendActivationMessage(payload)
      if (status) {
        void Alert({
          type: 'success',
          message: Format('admin_components_employee_employees_invitationemailsent'),
        })
      }
    },

    async MFACheck(payload: ICheckMFA) {
      const response = await userAPI.UserServices.MFACheck(payload)
      return response
    },

    async GetUserListReportExcel(data: IPaging) {
      await userAPI.UserServices.GetUserListReportExcel(data)
    },

    async GetEntraId(CompanyCode: string) {
      const { data, status } = await userAPI.UserServices.GetEntraId(CompanyCode)
      return status
        ? data
        : {
            entraApplicationClientId: null,
            entraObjectId: null,
            entraDirectoryTenantId: null,
            entraRedirectUrl: '',
          }
    },

    async GetActiveUserCount() {
      const { data, status } = await userAPI.UserServices.GetActiveUserCount()
      return status ? data : null
    },
  },
})
